var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isTrip)?_c('TripStatsContent'):(_vm.isTspTrip)?_c('TspTripStatsContent',{attrs:{"trip":_vm.trip}}):_c('TripStatsEmptyStateContent')
}
var staticRenderFns = []

export { render, staticRenderFns }